<script setup>
		import { ref } from 'vue'
		let isBarShown = ref(true)
    let date = new Date().toLocaleDateString();

    import { useSocketStore } from '@/stores/socketConnectionStore';
    const socketService = useSocketStore();

    const props = defineProps({
        header: String,
        message: String,
        cssClass: String,
        withLoading: Boolean,
        sentry: {
          type: [Boolean, String],
          default: false
        },
    })

		function hideBar() {
			isBarShown.value = false
		}

    function copyCode() {
      navigator.clipboard.writeText(props.sentry)
        .then(() => {
          socketService.handleSocketSuccess({
            header: 'Успешно',
            message: 'Код успешно скопирован в буфер обмена, сообщите его оператору!',
          })
        })
        .catch(err => {
          console.error('Ошибка при копировании кода:', err)
        })
    }
</script>

<template>
    <div v-show="isBarShown" role="alert" :class="`${cssClass} alert`">
        <div :class="`${cssClass} alert-heading d-flex justify-content-between align-items-center p-2`">
            <div v-if="withLoading" class="spinner-border me-2" style="width: 20px; height: 20px; flex-shrink: 0;" role="status"/>
            <h6 class="m-0">{{ header }}</h6>
						<button type="button" class="btn-close btn-close-white" @mousedown="hideBar"></button>
        </div>
        <div class="alert-body p-3">
            <span class="text-center">{{ message }}</span>
            <div v-if="sentry" class="text-center">
              <span style="cursor: pointer; text-decoration: underline" @click="copyCode">Скопировать код</span>
            </div>
        </div>
  </div>
</template>

<style scoped>
    .alert{
        padding: 0;
        width: 395px;
        color: white;
        background: white !important;
    }
    .alert-heading{
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        margin: 0;
        font-weight: bold;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
    }
    .alert-body{
        color: black;
        background: white;
        max-height: 124px;
				overflow-y: scroll;
        font-size: 14px;
        white-space: break-spaces;
    }
</style>